/** @format */
import { ImageLoader } from 'next/legacy/image';

export enum ResponsiveLoaderType {
    CLOUDFLARE = 'cloudflare',
    CONTENTFUL = 'contentful',
}

export type ResponsiveLoader = {
    loader: ImageLoader | undefined;
    isLoaderEnabled: boolean;
};
